/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type FetchTermPageQueryVariables = Exact<{
  termType: Types.TermType;
}>;


export type FetchTermPageQuery = { term: { id: string, type: Types.TermType, title: string, body: MarkdownString } };


export const FetchTermPageDocument = gql`
    query FetchTermPage($termType: TermType!) {
  term(type: $termType) {
    id
    type
    title
    body
  }
}
    `;

/**
 * __useFetchTermPageQuery__
 *
 * To run a query within a Vue component, call `useFetchTermPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTermPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchTermPageQuery({
 *   termType: // value for 'termType'
 * });
 */
export function useFetchTermPageQuery(variables: FetchTermPageQueryVariables | VueCompositionApi.Ref<FetchTermPageQueryVariables> | ReactiveFunction<FetchTermPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchTermPageQuery, FetchTermPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchTermPageQuery, FetchTermPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchTermPageQuery, FetchTermPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchTermPageQuery, FetchTermPageQueryVariables>(FetchTermPageDocument, variables, options);
}
export function useFetchTermPageLazyQuery(variables?: FetchTermPageQueryVariables | VueCompositionApi.Ref<FetchTermPageQueryVariables> | ReactiveFunction<FetchTermPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchTermPageQuery, FetchTermPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchTermPageQuery, FetchTermPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchTermPageQuery, FetchTermPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchTermPageQuery, FetchTermPageQueryVariables>(FetchTermPageDocument, variables, options);
}
export type FetchTermPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchTermPageQuery, FetchTermPageQueryVariables>;